// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
    text-align: justify;
    padding: 5px;
}

hr {
    color: #444444;
    opacity: .25;
    margin-top: 5%;
    margin-bottom: 5%;
}

ul li {
    padding: 5px;
}

ol li {
    padding: 7px;
}

.card {
    max-width: 900px;
    margin: 0 auto;
    background-color: #ffffff;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    margin-top: 2%;
    margin-bottom: 2%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header {
    padding: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.txt {
    text-align: center;
    margin-top: -10px;
}

.title {
    background-color: #4a1564;
    color: #ffffff;
    display: flex;
    justify-content: center;
    text-align: center;
    padding: 1%;
    margin-top: 5%;
}

.info {
    border: 0.5px solid #4a1564;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #AB8000;
}

.link {
    color: #AB8000;
    text-decoration: underline;
    font-weight: bold;
}

.contxt {
    text-align: center;
    margin-top: 20px;
    font-size: small;
}


.footer {
    background-color: #f5f5f5;
    padding: 15px;
}

.ftr {
    text-align: center;
    color: #888888;
    font-size: small;
}

.info-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 5px;
    padding: 0;
    margin: 0;
    text-align: center;
}

.icon {
    width: 40px;
    height: 40px;
    padding-top: 15px;
    padding: 5px;
}

.badge {
    width: 120px;
    height: auto;
}

.badge-wrapper {
    margin: 15px 10px;
}

.list {
    margin-top: 20px;
}

.msg {
    text-align: center;
    font-size: small;
    font-style: italic;
    color: #444444;
    margin-top: 20px;
}

h3 {
    font-size: 25px;
    text-align: center;
    margin-top: 0;
}

@media screen and (max-width: 600px) {
    .card {
        width: 100%;
    }

    .img img {
        max-width: 100%;
    }

    .bg {
        max-width: 100%;
        max-height: 500px;
        width: auto;
        height: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/mainStyle.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["p {\n    text-align: justify;\n    padding: 5px;\n}\n\nhr {\n    color: #444444;\n    opacity: .25;\n    margin-top: 5%;\n    margin-bottom: 5%;\n}\n\nul li {\n    padding: 5px;\n}\n\nol li {\n    padding: 7px;\n}\n\n.card {\n    max-width: 900px;\n    margin: 0 auto;\n    background-color: #ffffff;\n    border: 1px solid #dddddd;\n    box-sizing: border-box;\n    margin-top: 2%;\n    margin-bottom: 2%;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.header {\n    padding: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.txt {\n    text-align: center;\n    margin-top: -10px;\n}\n\n.title {\n    background-color: #4a1564;\n    color: #ffffff;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    padding: 1%;\n    margin-top: 5%;\n}\n\n.info {\n    border: 0.5px solid #4a1564;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #AB8000;\n}\n\n.link {\n    color: #AB8000;\n    text-decoration: underline;\n    font-weight: bold;\n}\n\n.contxt {\n    text-align: center;\n    margin-top: 20px;\n    font-size: small;\n}\n\n\n.footer {\n    background-color: #f5f5f5;\n    padding: 15px;\n}\n\n.ftr {\n    text-align: center;\n    color: #888888;\n    font-size: small;\n}\n\n.info-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 5px;\n    padding: 0;\n    margin: 0;\n    text-align: center;\n}\n\n.icon {\n    width: 40px;\n    height: 40px;\n    padding-top: 15px;\n    padding: 5px;\n}\n\n.badge {\n    width: 120px;\n    height: auto;\n}\n\n.badge-wrapper {\n    margin: 15px 10px;\n}\n\n.list {\n    margin-top: 20px;\n}\n\n.msg {\n    text-align: center;\n    font-size: small;\n    font-style: italic;\n    color: #444444;\n    margin-top: 20px;\n}\n\nh3 {\n    font-size: 25px;\n    text-align: center;\n    margin-top: 0;\n}\n\n@media screen and (max-width: 600px) {\n    .card {\n        width: 100%;\n    }\n\n    .img img {\n        max-width: 100%;\n    }\n\n    .bg {\n        max-width: 100%;\n        max-height: 500px;\n        width: auto;\n        height: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
